import React from 'react';
import { Box, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';

const Logo = ({ variant = 'default', size = 'medium' }) => {
  const sizes = {
    small: { icon: 24, text: 'h6' },
    medium: { icon: 32, text: 'h5' },
    large: { icon: 48, text: 'h4' },
  };

  const variants = {
    default: {
      color: 'primary.main',
      text: 'Junior Olympiad',
    },
    white: {
      color: 'white',
      text: 'Junior Olympiad',
    },
    minimal: {
      color: 'primary.main',
      text: 'JO',
    },
  };

  const currentSize = sizes[size];
  const currentVariant = variants[variant];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: currentVariant.color,
      }}
    >
      <SchoolIcon sx={{ fontSize: currentSize.icon }} />
      <Typography
        variant={currentSize.text}
        component="span"
        sx={{ fontWeight: 'bold' }}
      >
        {currentVariant.text}
      </Typography>
    </Box>
  );
};

export default Logo; 